"use client"

import Link from "next/link"

export default function NotFoundPage() {
  return (
    <div>
      Not found.
      <br />
      <Link href="/">Back to top.</Link>
    </div>
  )
}
